import {
  CREATING_SOURCE_SETTING,
  CREATED_SOURCE_SETTING,
  CREATE_SOURCE_SETTING_ERROR
} from 'actions'
import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'

const reducer = createApiMiddlewareReducer({
  request: CREATING_SOURCE_SETTING,
  failure: CREATE_SOURCE_SETTING_ERROR,
  receive: CREATED_SOURCE_SETTING
})

export default function (state = {}, { type, payload = {} }) {
  // payload can be any type, includ null (https://github.com/acdlite/flux-standard-action#payload)
  // here, if payload === null, this reducer throws
  if (payload === null) return state
  const { workspaceSlug } = payload
  switch (type) {
    case CREATING_SOURCE_SETTING:
    case CREATE_SOURCE_SETTING_ERROR:
    case CREATED_SOURCE_SETTING:
      return {
        ...state,
        [workspaceSlug]: reducer(state[workspaceSlug], { type, payload })
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/create-source-setting-request.js